const Navigations = [
    {
        id: 1,
        name: "HOME",
        url: "/",
    },
    {
        id: 4,
        name: "COLLECTIONS",
        url: "/connectwallet",
    },
    {
        id: 6,
        name: "RAID",
        url: "#raid",
    },
];

const MintNavigations = [
    {
        id: 1,
        name: "HOME",
        url: "/",
    },
    {
        id: 2,
        name: "COLLECTIONS",
        url: "/connectwallet",
    },
    {
        id: 3,
        name: "MINT",
        url: "/mint",
    },
];

export { Navigations, MintNavigations };